import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-process-first-time-through-yield-calculator',
  templateUrl: './process-first-time-through-yield-calculator.component.html',
  styleUrls: ['./process-first-time-through-yield-calculator.component.css']
})
export class ProcessFirstTimeThroughYieldCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  firstTime(n1,n2){
    var firTime=(n1-n2)/n1;
    var firTimepercent= firTime*100;
    var firTimesimple= firTimepercent.toFixed(2);
    return firTimesimple ;
    }
}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/process-first-time-through-yield-calculator/process-first-time-through-yield-calculator.component.ts